var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeIconFilter = function SvgHomeIconFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    overflow: "visible"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#home_icon_filter_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#000",
    fillOpacity: 0.2,
    rx: 15
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.5,
    height: 29.5,
    x: 0.25,
    y: 0.25,
    stroke: "#fff",
    strokeOpacity: 0.2,
    strokeWidth: 0.5,
    rx: 14.75
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#847379",
    d: "M22.4 9.9q-.15-.45-.6-.6c-.3-.2-.6-.2-.9-.2H9.5c-.3 0-.6 0-.9.2q-.45.3-.6.6c-.1.3-.1.5 0 .8 0 .3.2.5.4.7l5.2 4.4v4.4c0 .2 0 .3.2.4l2.4 2.2s.1.1.2.1h.6c.1 0 .2-.1.3-.2 0-.1.1-.2.1-.3v-6.6l4.7-4.4c.2-.2.4-.4.4-.7s0-.5-.1-.8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "home_icon_filter_svg__a",
    width: 34,
    height: 34,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_23772_35184"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_23772_35184",
    result: "shape"
  })))));
};
export default SvgHomeIconFilter;